import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreServiceService } from '../core/core-service.service';
import { SelectOccupancy } from '../Models/select-occupancy';

@Injectable({
  providedIn: 'root'
})
export class OccupancyService {
  private BaseApiPath: string;
  constructor(private http: HttpClient, private coreService: CoreServiceService) {

    this.BaseApiPath = this.coreService.appSettings && this.coreService.appSettings.ParkBaseApiPath;

  }

  public SelectOccupancy(selectOccupancy: SelectOccupancy): Observable<SelectOccupancy> {
    const ApiUrl = this.BaseApiPath + 'selectoccupancy/SelectOccupancy';
    return this.http.post<SelectOccupancy>(ApiUrl, selectOccupancy);
  }

}
